import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function writingListPath(preview, search = '') {
  const source = new URLSearchParams(search);
  const params = new URLSearchParams();
  // Return to the project library without replaying review or creation actions.
  for (const key of ['q', 'stage', 'sort']) {
    if (source.get(key)) params.set(key, source.get(key));
  }
  const query = params.toString();
  return `${preview ? '/prototype/vnext/writing' : '/writing'}${query ? `?${query}` : ''}`;
}

export function useReturnToWritingList(preview, projectId) {
  const navigate = useNavigate();
  const { state } = useLocation();
  return useCallback(() => {
    const root = writingListPath(preview);
    const saved = state?.writingListReturn;
    const fromList = saved && (saved.path === root || saved.path?.startsWith(`${root}?`));
    const target = fromList ? saved : { path: root, projectId, offset: 24 };
    navigate(target.path, { state: { writingListReturn: target } });
  }, [navigate, preview, projectId, state]);
}
